import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const creditTypes: Record<string, string> = {
  '1': 'Agency Law',
  '2': 'Legal Issues',
  '3': 'Fair Housing',
  '4': 'Contract Law',
  '5': 'Comm. Standards',
  '6': 'Disclosure',
  '7': 'General',
  '8': 'NONE',
  '9': 'Req. For Licensees'
};
export function EditCreditType() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  const name = id && creditTypes[id] ? creditTypes[id] : '';
  return <div className="space-y-4" data-id="element-661">
      <div className="flex items-center justify-between" data-id="element-662">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-663">
          {isEdit ? 'Edit Credit Type' : 'Add Credit Type'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types')} data-id="element-664">
          ← Back to Credit Types
        </Button>
      </div>

      <Card data-id="element-665">
        <CardContent className="pt-6" data-id="element-666">
          <form className="space-y-4 max-w-sm" data-id="element-667">
            <Input label="Name" defaultValue={name} data-id="element-668" />
            <div className="pt-2" data-id="element-669">
              <Button type="submit" data-id="element-670">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}